define('SuiteDynamics.PLPCanonicalURL.FacetsExtensions',
	[
		'SuiteDynamics.Facets.Browse.View.Extended'
	]
,   function (
		FacetsExtensions
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container) {
		}
	};
});
